// src/pages/Projects/ProjectVideoPage.jsx

import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { getProjectsApi } from "../../app/api";

export default function ProjectVideoPage() {
  const { id } = useParams();
  const [videoUrl, setVideoUrl] = useState("");

  useEffect(() => {
    fetchVideo();
  }, []);

  //   const fetchVideo = async () => {
  //     const res = await getProjectsApi();
  //     const project = res.data.find((p) => p.id === Number(id));
  //     if (project) {
  //     //   setVideoUrl(project.flow_video);
  //     const BASE_URL = "https://uptask.visiontrek.io"; // your backend domain

  // setVideoUrl(`${BASE_URL}${project.flow_video}`);
  //     }
  //   };
  const fetchVideo = async () => {
    const res = await getProjectsApi();

    let foundVideo = "";

    res.data.forEach((project) => {
      project.services?.forEach((service) => {
        if (service.id === Number(id)) {
          // const BASE_URL = "https://uptask.visiontrek.io";
          const BASE_URL = "https://demouptask.visiontrek.io";

          foundVideo = `${BASE_URL}${service.flow_video}`;
        }
      });
    });

    if (foundVideo) {
      setVideoUrl(foundVideo);
    }
  };
  return (
    <div className="flex items-center justify-center bg-black md:mt-20 h-[260px]">
      {videoUrl ? (
        <video
          src={videoUrl}
          controls
          autoPlay
          className="w-[80%] rounded-xl shadow-lg"
        />
      ) : (
        <p className="text-white">No video found</p>
      )}
    </div>
  );
}